
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter, namespace } from "vuex-class";
import vSelect from "vue-select";
import api from "../../services/api.views.service";
import { ShareWithPerson } from "@/store/site-monitor/types";
import Multiselect from "vue-multiselect";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { FeaturesList } from "@/store/types";
import { get } from "lodash";

const SiteMonitor = namespace("siteMonitor");

@Component({
	components: {
		"v-select": vSelect,
		multiselect: Multiselect,
		VuePerfectScrollbar: VuePerfectScrollbar
	}
})
export default class ViewShare extends Vue {

	@Getter("getFeaturesList") public featuresList: FeaturesList;

	@Prop({ type: Object, default: {}}) view: any;
	@Prop(Boolean) isShown: boolean;

	@Getter getUserName;
	@Getter isFullUser;
	@SiteMonitor.Getter("shareWithPersons") availableUsers: ShareWithPerson[];
	@SiteMonitor.Action eventShareSearch: any;

	private usersToShareWith: any[] = [];
	private shareFormAdhocUserName: string = "";
	private shareFormAdhocEmail: string = "";
	private viewSharesForSession: any = {};
	private usersSharedDuringSession: any = [];
	private userHasBeenShared: boolean = false;
	private shareViewWithAdhocResponse: any = {};

	@Watch("view")
	private async viewChanged(newView) {
		this.usersToShareWith = [];
		this.shareFormAdhocUserName = "";
		this.shareFormAdhocEmail = "";
		this.viewSharesForSession = {};
		this.usersSharedDuringSession = [];
		this.userHasBeenShared = false;
		this.shareViewWithAdhocResponse = {};
	}

	@Watch("isShown")
	private async isShownUpdated(newValue) {
		if (newValue) {
			this.viewSharesForSession = await api.getViewSharesForView(this.view.viewId);
		}
	}

	private async shareView() {	
		if (this.usersToShareWith.length > 0) {
			var userIdsToShareView = this.usersToShareWith.map(u => { return u.userID });
			await api.shareView(this.view.viewId, userIdsToShareView);
			this.viewSharesForSession = await api.getViewSharesForView(this.view.viewId)
			userIdsToShareView.forEach(userId => {
				var userDetails = this.viewSharesForSession.viewUsers.find(user => user.userId === userId);
				userDetails.isEmailDismissed = false;
				this.usersSharedDuringSession.push(userDetails);
			});
		}
		this.usersToShareWith = [];
		this.userHasBeenShared = true;
	}

	private async shareViewWithAdhoc() {
		if (this.shareFormAdhocUserName && this.shareFormAdhocEmail) {
			this.shareViewWithAdhocResponse = await api.shareViewWithAdhoc(this.view.viewId, this.shareFormAdhocUserName, this.shareFormAdhocEmail);
			this.viewSharesForSession = await api.getViewSharesForView(this.view.viewId);
			var userDetails = this.viewSharesForSession.viewUsers.find(user => user.fullName === this.shareViewWithAdhocResponse.fullName);
			userDetails.isEmailDismissed = false;
			userDetails.adHocAccessCode = this.shareViewWithAdhocResponse.accessCode;
			userDetails.shareID = this.shareViewWithAdhocResponse.shareID;
			this.usersSharedDuringSession.push(userDetails);
			this.userHasBeenShared = true;
		}
	}

	private get modalTitle() {
		return `Share details for ${this.view.title}`
	}

	private buildAdhocShareUrlForUser(userDetails: any) {
		return this.getViewsBaseUrl() + "/access/" + userDetails.shareID;
	}

	private get viewUrl() {
		return this.getViewsBaseUrl() + `?id=${this.view.viewId}`;
	}

	public get adHocEnabled() {
		if (get(this.featuresList, ["Views", "AdHocSharing"]) == null) {
			return false;
		} else {
			return get(this.featuresList, ["Views", "AdHocSharing"]);
		}
		
	}

	private getViewsBaseUrl() {
		// Clear any extra query params etc. from URL
		return window.location.href.substring(0, window.location.href.indexOf('/views')) + "/views";
	}

	private async removeShare(userToRemove) {
		var removeSuccess = false;
		if (userToRemove.adHocAccessCode) {
			removeSuccess = await api.removeAdhocUserShare(this.view.viewId, userToRemove.name);
		}
		else {
			removeSuccess = await api.removeUserShare(this.view.viewId, userToRemove.userId);
		}
		if (removeSuccess) {
			var indexOfUserToUpdate = this.viewSharesForSession.viewUsers.indexOf(userToRemove);
			this.viewSharesForSession.viewUsers[indexOfUserToUpdate].removed = true;
		}
	}

	private isLoading: boolean = false;
	private async viewShareFind(query: any) {
		this.isLoading = true;
		try {
			await this.eventShareSearch(query);
			this.isLoading = false;
		} catch (e) {
			this.isLoading = false;
		}
	}

	private copyEmailTemplateToClipboard(idToCopy: string) {
		var node = document.getElementById(idToCopy);
		var range = document.createRange();
		range.selectNodeContents(node);
		window.getSelection().removeAllRanges();
		window.getSelection().addRange(range);
		document.execCommand("copy");
	}

	private dismissEmailDialogForUser(userDetails: any) {
		var indexOfUserToUpdate = this.usersSharedDuringSession.findIndex(u => u.userId === userDetails.userId);
		userDetails.isEmailDismissed = true;
		Vue.set(this.usersSharedDuringSession, indexOfUserToUpdate, userDetails);
	}
	
	private removeSelectedUser(user) {
		this.usersToShareWith.splice(this.usersToShareWith.indexOf(user), 1);
	}
}
